// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2Etke","title":"BackImages_title__iOV2k","images":"BackImages_images__2v3kp"};